export const getCategories = state => state.category.categoryList;
export const getCategoryDetails = (state) => state.category.categoryDetails;

